import { useMemo } from "react";

import { useMatch } from "react-router-dom";

import { useCustomerIdentityAttrs } from "@/components/fastshift/analytics";
import { SourceKey } from "@/components/fastshift/analytics/constants";

import {
    FASTSHIFT_PATHS,
    FASTSHIFT_PATH_KEYS
} from "../../../routes/constants";

export const useRelationshipsAnalyticsData = () => {
    const identityAttrs = useCustomerIdentityAttrs();

    // Use useMatch for simpler, automatic route matching
    const planningMatch = useMatch(
        `/${FASTSHIFT_PATHS[FASTSHIFT_PATH_KEYS.PLANNING]}`
    );
    const overviewMatch = useMatch(
        `/${FASTSHIFT_PATHS[FASTSHIFT_PATH_KEYS.OVERVIEW]}`
    );

    const sourceKey = useMemo(() => {
        if (planningMatch) {
            return SourceKey.FASTSHIFT_PORTAL_MIGRATION_PLANNING_SCREEN;
        } else if (overviewMatch) {
            return SourceKey.FASTSHIFT_PORTAL_FOR_YOU_SCREEN;
        }

        return undefined;
    }, [planningMatch, overviewMatch]);

    return {
        sourceKey,
        identityAttrs
    };
};
